export default {
  title: "",
  subtitle: "Person Updates, Details and Search",
  path: "person_generals",
  paragraphs: [
    "To update a person’s information, you can use the endpoint below:",
    "Note: You can update all fields except for document_number and document_type."
  ],
  request: {
    method: "PUT",
    endpoint: "/subject/people/:id",
    payload: {
      "person": {
        "net_monthly_average_income": "2000"
      }
    },
    responses: {
      "data": {
        "updated_at": "2025-07-09T13:51:30.989491",
        "status": "approved",
        "social_name": "Joaquim dos Santos",
        "rfc_pf": null,
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "phone_country_code": null,
        "phone_area_code": null,
        "net_monthly_average_income": "2000",
        "inserted_at": "2023-12-11T14:11:02.571103",
        "id": "5fd0aa81-b427-4a29-9968-6491d1d7f8b0",
        "fiscal_country": "Brasil",
        "email": "joaquim.santos@gmail.com",
        "documents": [],
        "document_type": "cpf",
        "document_number": "70590071050",
        "clearance_level": 1,
        "birth_date": null,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_neighborhood": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null
      }
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Person UUID"
    }
  ],
   troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'If you try to update document number',
        code:{
                  "errors": {
                      "document_number": [
                          "Cannot change document number"
                      ]
                  }
              },
        solution: 'It is not possible to update the document_number and document_type.'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonGenerals.js